const r = {
  "top-left": "top-0 bottom-0 left-0 justify-start items-start",
  "top-right": "top-0 bottom-0 right-0 justify-start items-end",
  "bottom-left": "top-0 bottom-0 left-0 justify-end items-start",
  "bottom-right": "top-0 bottom-0 right-0 justify-end items-end"
}, t = {
  stack: "w-[22.5rem]",
  inline: "lg:w-[47.5rem] w-full"
}, e = {
  light: {
    neutral: "border-alert-border-neutral bg-alert-background-neutral",
    custom: "border-alert-border-neutral bg-alert-background-neutral",
    info: "border-alert-border-info bg-alert-background-info",
    success: "border-alert-border-green bg-alert-background-green",
    warning: "border-alert-border-warning bg-alert-background-warning",
    error: "border-alert-border-danger bg-alert-background-danger"
  },
  dark: "bg-background-inverse border-background-inverse"
}, o = {
  light: "text-icon-secondary",
  dark: "text-icon-inverse"
};
export {
  o as closeIconClassNames,
  t as containerVariantClassNames,
  r as positionClassNames,
  e as variantClassNames
};
//# sourceMappingURL=component-style.es.js.map
